import { TabularTypeSettings } from 'app/model/dataflow/dataset-settings/tabular-type-settings';
import { AzureDataExplorerDataset, Metamodel } from 'shell-models-lib';
import { DatasetFormatType } from 'app/model/dataflow/dataset-settings/dataflow-dataset-settings';
import { DataFlowExpression } from 'app/model/dataflow/dataflowexpression';
import { DataFlowSource } from 'app/model/dataflow/dataflow-source';
import { IntegerDataFlowType } from 'worker/app-workers/shared/models/dataflow-datatype';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

/**
 * Dataflow settings for Azure Data Explorer
 */
@Metamodel.model({
    name: adfModelTypeMap.azureDataExplorer.dataflowSettings
})
export class AdxSettings extends TabularTypeSettings {
    public isPreSqlsListOfExpression: boolean;
    public preSqls: DataFlowExpression[];
    public isPostSqlsListOfExpression: boolean;
    public postSqls: DataFlowExpression[];

    @Metamodel.attribute({
        constraint: {
            validator: DataFlowSource.validateTimeout
        }
    })
    public timeout: DataFlowExpression;

    public override get isDatabaseNameRequired(): boolean {
        return __IS_FABRIC_MDF__;
    }
    
    public initialize(subFormat: string): void {
        super.initialize(subFormat);
        this.timeout = this.transform.createTemplatableExpression(IntegerDataFlowType.TYPE);
        this.isPreSqlsListOfExpression = true;
        this.isPostSqlsListOfExpression = true;
        this.preSqls = [this.transform.createTemplatableExpression()];
        this.postSqls = [this.transform.createTemplatableExpression()];
    }

    public getDatasetType(): string {
        return Metamodel.modelFor(AzureDataExplorerDataset).name;
    }

    public getFormat(): DatasetFormatType {
        return DatasetFormatType.ADX;
    }

    public getIconClass(): string {
        return 'i-100x100-azure_data_explorer';
    }

    public getSubFormat(): string {
        return undefined;
    }
}
